import { put } from 'redux-saga/effects';

import makeRequest from 'rdx/utils/makeRequest';
import putErrorActions from 'rdx/utils/putErrorActions';
import { newMessageEvent } from 'rdx/modules/messages/slice';

function* submitLead({ payload: { action, params, onSuccess, onError } }) {
  const { success, error } = yield* makeRequest.action(action, params);
  if (success) {
    if (onSuccess) {
      onSuccess();
    }
    yield put(newMessageEvent({ text: 'Request Submitted' }));
  } else {
    onError();
    yield* putErrorActions({ error });
  }
  return null;
}

export default submitLead;
